export type AssignmentNoteMap = {
  [key: number]: string;
};

// This map represents the assignment notes with their corresponding numeric keys.
export const assignmentNoteChangedMap: AssignmentNoteMap = {
  1: 'CHANGED_ADDRESS',
  2: 'CHANGED_UNCRITICAL',
  3: 'CHANGED_DELIVERY',
  4: 'CHANGED_PICKUP',
  5: 'CHANGED_CARGO',
  6: 'CHANGED_POSITION',
  7: 'CHANGED_POSITION',
  8: 'FINISHED',
};

export const assignmentNoteStateNoMap: AssignmentNoteMap = {
  9: 'CANCELED',
  7: 'ENQUIRY',
  6: 'COMPLETED',
};
